import { environment } from 'environments/environment';
import { Injectable } from '@angular/core';
import Utils from '@app/shared/utils/utils';

@Injectable()
export class UrlService {
  public API_URL = {
    AUTH: environment.API_URL_AUTH,
    CATALOG: environment.API_URL_CATALOG,
    COLLECT: environment.API_URL_COLLECT,
    COLLECT_TVF: environment.API_URL_COLLECT_VAREJO,
    COLLECT_TVO: environment.API_URL_COLLECT_VAREJO,
    RECERTIFICATION: environment.API_URL_RECERTIFICATION,
    RECERTIFICATION_TVF: environment.API_URL_RECERTIFICATION_VAREJO,
    RECERTIFICATION_TVO: environment.API_URL_RECERTIFICATION_VAREJO,
    MAINTENANCE_TVF: environment.API_URL_MAINTENANCE_VAREJO,
    API_URL_TVF_LOGS: environment.API_URL_TVF_LOGS,
    API_URL_DEALER: environment.API_URL_DEALER,
    API_URL_RECEIPT: environment.API_URL_RECEIPT,
  };

  public urlsList = {
    AUTH: {
      singIn: `${window.location.protocol}//demo6878679.mockable.io/login`,
      token: `/auth/realms/tradein/protocol/openid-connect/token`,
    },
    CATALOG: {},

    COLLECT: {
      saveToken: '/mobile/token',
      authenticate: '/keycloack/token',
      getUsers: '/keycloack/get-all-tradein-user',
      createUser: '/keycloack/create-user',
      confirmEmailResetPassword: '/keycloack/recover-password',
      resetUserPassword: '/keycloack/reset-user-password',
      updateUser: '/keycloack/update-user',
      getProfileGroups: '/keycloack/groups',
      deleteGroupProfile: '/keycloack/delete-group?GroupId={id}',
      updateGroupProfile: '/keycloack/update-group',
      postGroupProfile: '/keycloack/create-group',
      listProfileRoles: '/keycloack/roles-group',
      updatePostCodeDevolution: '/trades/updatePostCodeDevolution',
      countStatusTrade: `/trades/{idTrade}/countStatusTrade`,
      tradeByIdTrade: `/trades/{idTrade}/tradeOrder`,
      tradesByIdTrade: `/trades/{idTrade}`,
      getTradesFilterScreening: `/trades/{filter}/tradescreening/short`,
      tradesFiltred: `/trades/filtred`,
      saveAnswers: `/trades/{idTrade}/answers`,
      upload: `/trades/{idTrade}/upload`,
      downloadPDF: `/AssignmentTerm/trade/{idTrade}/getPdfById/{idAssignmentTerm}`,
      updateScreeningStep: `/trades/UpdateScreeningStep`,
      uploadFileChunk: `/trades/uploadFileChunk`,
      newAnalysisPrice: `/trades/new-analysis-price`,
      updateAdditionalInformation: `/trades/UpdateAdditionalInformation`,
      getAppleFinancialAccountingReportExport:
        '/trades/export-apple-financial-report?startDate={initialDate}&endDate={endDate}',
      createNewPostCodeTrade: '/trades/createNewPostCodeTrade',
      createStatusTrade: '/trades/{idTrade}/createStatusTrade/{idStatusTrade}',
      getOrderReport:
        '/trades/trades-report?page={page}&pageSize={pageSize}&startDate={startDate}&endDate={endDate}' +
        '&slaStart={slaStart}&slaEnd={slaEnd}&idTradeExternal={tradeId}',
      getReportAsExcelOperacional:
        '/trades/tradesScreeningExport?startDate={startDate}&endDate={endDate}' +
        '&slaStart={slaStart}&slaEnd={slaEnd}&idTradeExternal={tradeId}',
      getReportAsExcelComercial:
        '/trades/tradesExport?startDate={startDate}&endDate={endDate}' +
        '&slaStart={slaStart}&slaEnd={slaEnd}&idTradeExternal={tradeId}',
      downloadLaudo: '/trades/registro-laudo-tecnico?idTradeExternal={idTrade}',
      skipTrade: '/Tracking/skipStepTrade',
      sendImei: '/trades/update-imei-biped',
      getToken: '/mobile/token?Id={id}',
      getErrorList: '/trades/trades-with-create-purchase-note-error',
      getErrorsReportExport:
        '/trades/trades-with-create-purchase-note-error-export?IdTradeExternal={idTrade}',
      tradeReprocess: '/trades/enqueue-fixed-trades-to-process-note',
      getDivergenceReportExport: `/trades/export-trade-divergence?startDate={startDate}&endDate={endDate}&statusTrade={statusTrade}`,
      budgetReportExport: `/trades/funds-report?startDate={startDate}&endDate={endDate}`,
      rollbackToScreeningStep: `/trades/rollback-to-recertifier-checklist-step?idTradeExternal={idTrade}`,
      setToMisplaced: `/trades/misplaced`,
      getKeepReportExport:
        '/keep/keep-export?startDate={startDate}&endDate={endDate}&orderId={orderId}',
      listProcessingCosts: '/afs-report-process-cost-value/list-process-cost-values',
      getProcessingCost: '/afs-report-process-cost-value/list-process-cost-values?year={year}',
      addProcessingCost: '/afs-report-process-cost-value/add-processing-cost-value',
      updateProcessingCost: '/afs-report-process-cost-value/update-process-cost-values',
      getProductList: '/product/products-description',
      updateProductDescription: '/trades/product-update',
      resetScreening: '/trades/reset-screening',
      deleteFilePathTrade: `/trades/delete-s3-files`,
      postCloseScreening: '/trades/closeScreening',
      getAddicionalInfo: `/trades/{idTrade}/additionalInformation`,
      getCheckListResult: `/trades/{idTrade}/checklist-summary`,
      getDivergenceReport: `/trades/{idTrade}/divergence-reason`,
      getProductReturnLabel: '/trades/get-product-return-label?idTradeExternal={idTradeExternal}',
      changeUserStatus: `/keycloack/change-user-status`,
      postGeneratePresignedUrl: '/upload-media/generate-presigned-url',
      postRegisterUploadedMedia: '/trades/register/upload',
      getTradeGallery: `/trades/{idTrade}/gallery`,
      getImeiAvailability: `/trades/validate-imei-availability?imei={imei}&idtradeExcepts={idtradeExcepts}`,
      getTimelineReport:
        '/trades/report/timeline/export?StartDate={startDate}&EndDate={endDate}&IdTrade={idTrade}',
      reopeningWindow: `/trades/reopening`,
      listReopenings: `/trades/reopenings?OrderId={idOrder}&Page={page}&PageSize={pageSize}`,
      validateTechnicalReport: '/trades/{idTrade}/validate-technical-report',
      getLogsList:
        '/trades/log-integration?Page={page}&PageSize={pageSize}&IdTradeExternal={idTrade}&startDate={startDate}&endDate={endDate}',
      resumeTrades: '/trades/trades-report-summary-export?startDate={startDate}&endDate={endDate}',
      historyCustomerLocations: '/trades/{idTrade}/customer-address-change-history',
      updateCustomerLocation: '/trades/fix-customer-address-city-or-uf-to-create-purchase-note',
    },
    COLLECT_TVF: {
      authenticate: '/keycloack/token',
      saveToken: '/mobile/token',
      getToken: '/mobile/token?Id={id}',
      updatePostCodeDevolution: '/trades/updatePostCodeDevolution',
      countStatusTrade: `/trades/{idTrade}/countStatusTrade`,
      tradeByIdTrade: `/trades/{idTrade}/tradeOrder`,
      tradesByIdTrade: `/trades/{idTrade}`,
      getTradesFilterScreening: `/trades/{filter}/tradescreening/short`,
      tradesFiltred: `/trades/filtred`,
      saveAnswers: `/trades/{idTrade}/answers`,
      upload: `/trades/{idTrade}/upload`,
      downloadPDF: `/AssignmentTerm/trade/{idTrade}/getPdfById/{idAssignmentTerm}`,
      updateScreeningStep: `/trades/UpdateScreeningStep`,
      uploadFileChunk: `/trades/uploadFileChunk`,
      deleteFilePathTrade: `/trades/delete-s3-files`,
      newAnalysisPrice: `/trades/new-analysis-price`,
      setToMisplaced: `/trades/misplaced`,
      updateAdditionalInformation: `/trades/UpdateAdditionalInformation`,
      getTvfFinancialAccountingReportExport:
        '/trades/export-tvf-financial-report?startDate={initialDate}&endDate={endDate}',
      createNewPostCodeTrade: '/trades/createNewPostCodeTrade',
      createStatusTrade: '/trades/{idTrade}/createStatusTrade/{idStatusTrade}',
      getOrderReport:
        '/trades/trades-report?page={page}&pageSize={pageSize}&startDate={startDate}&endDate={endDate}' +
        '&slaStart={slaStart}&slaEnd={slaEnd}&idTradeExternal={tradeId}',
      getReportAsExcelOperacional:
        '/trades/tradesScreeningExport?startDate={startDate}&endDate={endDate}' +
        '&slaStart={slaStart}&slaEnd={slaEnd}&idTradeExternal={tradeId}',
      getReportAsExcelComercial:
        '/trades/tradesExport?startDate={startDate}&endDate={endDate}' +
        '&slaStart={slaStart}&slaEnd={slaEnd}&idTradeExternal={tradeId}',
      getTimelineReport:
        '/trades/report/timeline/export?StartDate={startDate}&EndDate={endDate}&IdTrade={idTrade}',
      downloadLaudo: '/trades/registro-laudo-tecnico?idTradeExternal={idTrade}',
      skipTrade: '/Tracking/skip-status-trade',
      sendImei: '/trades/update-imei-biped',
      getErrorList: '/trades/trades-with-create-purchase-note-error',
      errorsReportExport: '/logs/list-dlq-messages-retried-with-error-export',
      tradeReprocess: '/trades/enqueue-fixed-trades-to-process-note',
      getDivergenceReportExport: `/trades/export-trade-divergence?startDate={startDate}&endDate={endDate}`,
      saveEvidence: '/trades/register/evaluation/evidence',
      getTradeGallery: `/trades/{idTrade}/gallery`,
      getTradeGalleryThirdParty: `/trades/{idTrade}/gallery-third-party`,
      postCloseScreening: '/trades/closeScreening',
      getTradeTag: `/trades/trade-tag/{idTrade}`,
      getDellocatedTradesToSaveToLot: `/trades/get-deallocated-trades-to-save-to-lot`,
      getLots: '/lots',
      getRecertifiersManualCotationByTrade: '/trades/{idTrade}/repricing',
      exportLotReport: '/lots/export-lot-report?idLot={idLot}',
      postGeneratePresignedUrl: '/upload-media/generate-presigned-url',
      postRegisterUploadedMedia: '/trades/register/evaluation/evidence',
      getImeiAvailability: `/trades/validate-imei-availability?imei={imei}&idtradeExcepts={idtradeExcepts}`,
      listProcessingCosts: `/fs-report-process-cost-value/list-process-cost-values`,
      getProcessingCost: `/fs-report-process-cost-value/list-process-cost-values?year={year}`,
      addProcessingCost: `/fs-report-process-cost-value/add-processing-cost-value`,
      updateProcessingCost: `/fs-report-process-cost-value/update-process-cost-values`,
      listCarriers: `/transports?Page={page}&PageSize={pageSize}&search={search}`,
      listCarriersOptions: `/transports/combobox`,
      manageCarriers: `/transports`,
      removeCarriers: `/transports/{id}`,
      getLogsList: `/trades/log-integration?Page={page}&PageSize={pageSize}&IdTrade={idTrade}&startDate={startDate}&endDate={endDate}`,
      addRetailer: '/Retailer',
      getRetailerList: '/Retailer?Page={page}&pageSize={pageSize}&search={searchField}',
      updateRetailer: '/Retailer/{retailerCurrentId}',
      deleteRetailer: '/Retailer/{retailerId}',
      getPrograms: '/Program',
      listStores: '/stores?pageSize={pageSize}&search={search}&Page={page}',
      listStoresOptions: '/stores/combobox',
      addStore: '/stores',
      updateStore: '/stores/{storeId}',
      trackingReportExport:
        '/reports/tracking-report-export?StartDate={startDate}&EndDate={endDate}&TrackingReportType={status}',
      importStoreXlsxFile: '/stores/import-stores',
      editStoreXlsxFile: '/stores/import',
      exportStoreXlsxFile: '/stores/export-stores',
      importLinkCarrierStoreXlsx: '/stores/import-link-transport-store',
      exportLinkCarrierStoreXlsx: '/stores/export-link-transport-store',
      createPendency: '/trades/create-pendency',
      pendencyIssues: '/trades/{idTrade}/pendency?ProtocolGlpi={ProtocolGlpi}&Status={status}',
      closePendency: '/trades/{idTrade}/close-pending',
      exportPendency:
        '/trades/trades-pendency-export?IdTradeExternal={idTrade}&Status={status}&StartDate={startDate}&EndDate={endDate}',
      registerFullAccess: '/keycloack/register-fullaccess-mock-token',
      historyCustomerLocations: '/trades/{idTrade}/customer-address-change-history',
      updateCustomerLocation: '/trades/fix-customer-address-city-or-uf-to-create-purchase-note',
      listDlqs:
        '/logs/list-dlq-messages-retried-with-error?Page={page}&PageSize={pageSize}&IdTrade={idTrade}&startDate={startDate}&endDate={endDate}',
      resendFailedCollection: '/tracking/resend-failed-collection',
      invoicesReport: `/trades/export-external-assistance-report?startDate={initialDate}&endDate={endDate}`,
      reprocessDlqs: '/messaginges',
      verifyImei: '/trades/verifyImei?IdTrade={idTrade}',
      reprocessPackageDlqs: '/messaginges/messaginges-batch',
      revertExtravio: '/trades/reverse-misplaced',
      companyHistory: '/trades/{idTrade}/history',
      company: '/trades/{idTrade}/company',
      imeiDetail: '/trades/imei/{search}',
      searchRelapseTradesByFilter: '/recurrences/eligible?filter={filter}',
      getRelapseQuestions: '/recurrences/questions?TradeId={tradeId}&AnswerId={answerId}',
      getHistoryTradeByImei: '/recurrences/history/{imei}',
      listRecurrences: '/recurrences?Search={search}&Page={page}&PageSize={pageSize}',
      exportRecurrencesExcel: '/recurrences/export/excel?Search={search}&Page={page}&PageSize={pageSize}',
      downloadLaudoPdfB2c: '/recurrences/laudo/b2c/download/pdf',
      getLaudoDataB2c: '/recurrences/laudo/b2c',
      getLaudoDataB2b: '/recurrences/laudo/b2b',
      downloadLaudoPdfB2b: '/recurrences/laudo/b2b/download/pdf',
    },

    MAINTENANCE_TVF: {},

    RECERTIFICATION_TVF: {
      getUserAnswer: '/Answered/{idTrade}',
      getIdentification: `/InternalRevaluation/Identification`,
      getDeviceConditionQuestions: `/InternalRevaluation/DeviceConditionQuestions?descriptionEquipamentType=Smartphone`,
      saveInternalRevaluation: `/InternalRevaluation/SaveInternalRevaluation`,
      getPricing: `/Operation/subCategory/getall`,
      getPricingDetails: `/Operation/subCategory/logic/{idLogic}`,
      editPricingDetails: `/Operation/subCategory/logic`,
      getevaluations: `/Recertifier/trade/evaluations?idTrade={idTrade}`,
      getRecertifiers: '/Recertifier/list',
      updateTradeRecertifier: `/InternalRevaluation`,
      getScreeningResult: `/InternalRevaluation/screening-result/{idTrade}`,
      getTradeTagInformations: `/InternalRevaluation/label/{idTrade}`,
      listCQPendingTrades: `/QualityControl/pending?page={page}&pageSize={pageSize}&TradeId={idTrade}`,
      disapproveCQ: `/QualityControl/repprove`,
      approveCQ: `/QualityControl/approve`,
      checklistCQ: `/QualityControl/repair-checklist?TradeId={tradeId}`,
      countRepproved: `/InternalRevaluation/count-reproved`,
      repairCountSum: `/QualityControl/repair-count-sum`,
      saveRecurrence: `/recurrence`,
      updateRecurrence: `/recurrence/edit`,
      repairTrackingCounters: '/RepairTracking/counters',
      repairTrackingSearch: '/RepairTracking/search',
      repairTrackingDetails: '/InternalRevaluation/lmr-history/{tradeId}',
    },

    RECERTIFICATION_TVO: {
      getevaluations: '/Recertifier/trade/evaluations?idTrade={idTrade}',
      getDeviceConditionQuestions: '/v1/InternalRevaluation/DeviceConditionQuestions?DescriptionEquipamentType=Smartphone',
      saveInternalRevaluation: '/v1/InternalRevaluation/SaveInternalRevaluation',
      getTradeTagInformations: '/v1/InternalRevaluation/label/{idTrade}',
      getScreeningResult: '/v1/InternalRevaluation/screening-result/{idTrade}',
    },

    RECERTIFICATION: {
      getUserAnswer: '/Answered/{idTrade}',
      getQuestions: `/Operation/{idOperation}/subCategory/{idsubcategory}/checklist?IdTrade={IdTrade}`,
      getPricing: `/Operation/subCategory/getall`,
      getPricingDetails: `/Operation/subCategory/logic/{idLogic}`,
      editPricingDetails: `/Operation/subCategory/logic`,
      getCheckLists: `/Operation/question/getall`,
    },

    COLLECT_TVO: {
      tradeByIdTrade: `/trades-online/{idTrade}/tradeOrder`,
      tradesFiltred: `/trades-online/filtred`,
      createPendency: '/trades/create-pendency',
      pendencyIssues: '/trades/{idTrade}/pendency?ProtocolGlpi={ProtocolGlpi}&Status={status}',
      closePendency: '/trades/{idTrade}/close-pending',
      exportPendency:
        '/trades-online/trades-pendency-export?IdTradeExternal={idTrade}&Status={status}&StartDate={startDate}&EndDate={endDate}',
      getOrderReport:
        '/trades-online/trades-report?page={page}&pageSize={pageSize}&startDate={startDate}&endDate={endDate}' +
        '&slaStart={slaStart}&slaEnd={slaEnd}&idTradeExternal={tradeId}',
      getOrderReportExport:
        '/trades-online/tradesExport?startDate={startDate}&endDate={endDate}' +
        '&slaStart={slaStart}&slaEnd={slaEnd}&idTradeExternal={tradeId}',
      trackingReportExport:
        '/trades-online/tracking-report-export?StartDate={startDate}&EndDate={endDate}&TrackingReportType={status}',
      countStatusTrade: `/trades-online/{idTrade}/countStatusTrade`,
      getTradesFilterScreening: `/trades-online/{filter}/tradescreening/short`,
      skipTrade: '/trades-online/skip-status-trade',
      postGeneratePresignedUrl: '/upload-media/generate-presigned-url',
      postRegisterUploadedMedia: '/trades/register/evaluation/evidence',
      updateScreeningStep: `/trades-online/UpdateScreeningStep`,
      getAddicionalInfo: `/trades-online/{idTrade}/additionalInformation`,
      resetScreening: '/trades-online/reset-screening',
      postCloseScreening: '/trades-online/closeScreening',
      getCheckListResult: `/trades-online/{idTrade}/checklist-summary`,
      getDivergenceReportExport: `/trades-online/export-trade-divergence?startDate={startDate}&endDate={endDate}&statusTrade={statusTrade}`,
      getTradeGallery: `/trades-online/{idTrade}/gallery`,
      getTradeGalleryThirdParty: `/trades/{idTrade}/gallery-third-party`,
      getDivergenceReport: `/trades-online/{idTrade}/divergence-reason`,
      updateCustomerLocation: '/trades/fix-customer-address-city-or-uf-to-create-purchase-note',
      historyCustomerLocations: '/trades/{idTrade}/customer-address-change-history',
      refusedPayment: '/trades-online/RefusePayment',
      createNewPostCodeTrade: '/trades-online/createNewPostCodeTrade',
    },

    API_URL_TVF_LOGS: {
      getErros: `/error-category/get-errors?Page={page}&PageSize={pageSize}&filter={filter}`,
      createError: `/error-category/create-error`,
      updateError: `/error-category/update-error`,
      deleteError: `/error-category/{idTrade}`,
    },

    API_URL_DEALER: {
      dealers: '/Fornecedor',
      updateDealer: '/Fornecedor/{id}',
      listBid: '/Fornecedor/pecas',
      suppliersBid: '/Fornecedor/all',
      historySuppliers: '/Importacoes/historico',
      importSupplier: '/Fornecedor/importar-pecas/{fornecedorId}',
      downloadImportFile: '/Importacoes/{supplierId}/download-importacao',
      importDefectSolution: '/DefeitoSolucao/importar',
      exportDefectSolution: '/DefeitoSolucao/exportar-template-importacao',
      listDefectSolution: '/DefeitoSolucao',
      exportTemplateImportBID: '/Importacoes/exportar-template',
      listMatriz: '/MatrizLmr',
      importMatriz: '/MatrizLmr/importar',
      templateMatriz: '/MatrizLmr/modelo',
      exportDataTable: '/pecas-exportar',
    },

    API_URL_RECEIPT: {
      listLots: '/Lote',
      lotsCombobox: '/Lote/combobox/aberto',
      newLot: '/Lote',
      submitReceipt: '/LoteItem',
      refusalReasons: '/LoteItem/motivos/recusa',
      uploadEvidence: '/LoteItem/upload',
      deleteEvidence: '/LoteItem/imagem',
      importBag: '/Saca',
      listWaybillItems: '/Lote/romaneio',
      printWaybill: '/Lote/download/romaneio?Id={lotId}&NumeroFolha={numeroFolha}',
      closeLot: '/Lote/fechar/{lotId}',
      removeWaybillItem: '/LoteItem/{itemId}',
      listLotsclosed: '/Lote/fechados',
      batchDelivery: '/Lote/entregar',
      resume: '/Carregamento/resumo',
      waitingLots: '/Carregamento/lotes-aguardando',
      loadingLots: '/Carregamento/lotes-em-carregamento',
      receiveLots: '/Carregamento/receber-lotes',
      removeTrades: '/Carregamento/retirar-trades',
      returnLots: '/Carregamento/devolver-lotes',
      downloadTermo: '/LoteItem/download/termo/{tradeId}',
    },
  };

  getUrl(label: string, params = {}, external: boolean = false): string {
    const [type, url] = label.split('.');
    let path = '';

    if (external) {
      path = this.urlsList[type][url];
    } else if (url) {
      path = this.API_URL[type] + this.urlsList[type][url];
    }

    return Utils.parseKeyText(path, params);
  }
}
